import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import { SERVICES, waLink } from "@/lib/site";
import { Reveal, Eyebrow } from "@/components/Reveal";

export const Services = () => (
  <section id="leistungen" data-testid="services-section" className="relative w-full bg-white text-[#0a0a0a] py-20 sm:py-24 lg:py-32">
    <div className="w-full px-5 sm:px-8 lg:px-12">
      <Reveal>
        <Eyebrow chapter="01" dark>
          Leistungen
        </Eyebrow>
      </Reveal>
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-12 lg:mb-16">
        <Reveal delay={0.05}>
          <h2 className="font-display uppercase font-black leading-[0.9] tracking-tight text-[clamp(2.2rem,7.5vw,5.6rem)] max-w-[1000px]">
            Unsere <span className="text-[#f95700]">Transportlösungen</span>
          </h2>
        </Reveal>
        <Reveal delay={0.12} className="max-w-md">
          <p className="text-[15px] sm:text-base text-neutral-600 leading-relaxed border-l-2 border-[#f95700] pl-5">
            Vom einzelnen Möbelstück über Paletten bis zum kompletten Umzug: Wir stellen Fahrzeug,
            Team und Ablauf passend zu Ihrer Ladung zusammen.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-px bg-neutral-200">
        {SERVICES.map((s, i) => (
          <motion.article
            key={s.slug}
            data-testid={`service-card-${s.slug}`}
            initial={{ opacity: 0, y: 36 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.7, delay: (i % 4) * 0.06, ease: [0.16, 1, 0.3, 1] }}
            className="group relative bg-white flex flex-col"
          >
            <Link to={`/leistungen/${s.slug}`} className="relative overflow-hidden aspect-[16/10] block">
              <img
                src={s.img}
                alt={s.title}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-[1.1s] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.07]"
              />
              <div className="absolute inset-0 bg-black/15 group-hover:bg-black/0 transition-colors duration-500" />
              <span className="absolute top-0 left-0 font-mono-t text-[10px] tracking-widest uppercase bg-black text-white px-3 py-1.5">
                {s.tag}
              </span>
              <span className="absolute bottom-0 right-0 font-mono-t text-[11px] bg-[#f95700] text-white px-2.5 py-1">
                {String(i + 1).padStart(2, "0")}
              </span>
            </Link>

            <div className="flex flex-col flex-1 p-5 sm:p-6 lg:p-7 border-t-2 border-transparent group-hover:border-[#f95700] transition-colors duration-500">
              <Link to={`/leistungen/${s.slug}`} data-testid={`service-detail-link-${s.slug}`}>
                <h3 className="font-display text-xl sm:text-2xl font-bold uppercase tracking-tight group-hover:text-[#f95700] transition-colors">
                  {s.title}
                </h3>
              </Link>
              <p className="mt-3 text-sm text-neutral-600 leading-relaxed flex-1">{s.text}</p>
              <div className="mt-6 pt-4 border-t border-neutral-200 flex items-center justify-between gap-3">
                <a
                  href={waLink(`Hallo Global Move Europa, ich interessiere mich für: ${s.title}. Bitte senden Sie mir ein Angebot.`)}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`service-cta-${s.slug}`}
                  className="inline-flex items-center gap-2 font-display text-sm font-bold uppercase tracking-wider text-[#0a0a0a] hover:text-[#f95700] transition-colors"
                >
                  <MessageCircle size={15} className="text-[#25D366]" />
                  Anfragen
                </a>
                <Link
                  to={`/leistungen/${s.slug}`}
                  aria-label={`${s.title} Details`}
                  className="inline-flex items-center gap-1 font-mono-t text-[11px] uppercase tracking-widest text-neutral-500 hover:text-[#f95700] transition-colors"
                >
                  Details
                  <ArrowUpRight size={14} />
                </Link>
              </div>
            </div>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
